import { useDispatch, useSelector } from 'react-redux';
import { Input, Tooltip } from 'antd';
import { TranslationOutlined, LoadingOutlined } from '@ant-design/icons';
import { withLocale } from '../../l10n';
import { setTranslation } from '../../store';
import {
  validateTranslate,
  validateTranslateDefaultLanguage,
  INVALID,
} from '../../utils/translateValidation';
import "./TranslationCell.scss";

/** Plantillas de los avisos, en español como el resto de los literales de Core. */
const AVISOS = {
  [INVALID.TOO_LONG]:      'La traducción no puede superar los {max} caracteres',
  [INVALID.CHARS]:         'La traducción contiene caracteres no válidos',
  [INVALID.EMPTY_DEFAULT]: 'La traducción por defecto no puede estar vacía',
};

function avisoDe({ reason, params }, lang) {
  const texto = lang.handle(AVISOS[reason] ?? '');
  return params?.max != null ? texto.replace('{max}', params.max) : texto;
}

/**
 * Celda editable de una traducción, con autotraducción en el propio input.
 * Se suscribe sólo a su entrada del borrador: escribir aquí no repinta el
 * resto de la tabla.
 */
function TranslationCell({ id, code, isDefault, hasContext, disabled, translating,
                           onTranslate, lang }) {
  const dispatch = useDispatch();

  const description = useSelector(
    (state) => state.translate.draft.byId[id]?.l10n?.translations?.[code]?.description
  );
  const value = String(description ?? '');

  // Cada celda se valida a si misma 
  const check = isDefault
    ? validateTranslateDefaultLanguage(value)
    : validateTranslate(value);

  const invalid = !check.isValid;

  // El idioma origen no se traduce a sí mismo: ahí no hay icono.
  const suffix = isDefault || disabled ? null : translating ? (
    <LoadingOutlined />
  ) : hasContext ? (
    <Tooltip title={lang.handle('Traducir con IA')}>
      <TranslationOutlined
        onClick={onTranslate}
        className="translation-cell__translate translation-cell__translate--on"
      />
    </Tooltip>
  ) : (
    <Tooltip title={lang.handle('Elija un contexto para poder traducir')}>
      <TranslationOutlined className="translation-cell__translate translation-cell__translate--off" />
    </Tooltip>
  );

  return (
    <Tooltip title={invalid ? avisoDe(check, lang) : ''} color="red">
      <Input
        value={value}
        disabled={disabled}
        status={invalid ? 'error' : undefined}
        suffix={suffix}
        onChange={(e) => dispatch(setTranslation({ id, code, value: e.target.value }))}
      />
    </Tooltip>
  );
}

export default withLocale(TranslationCell);
